<template>

    <!--TODO: Сделать настройки-->

    <div>

      <div v-if="load" class="text-center mb-10">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>

      <div v-else class="card card-custom gutter-b">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">Настройки</span>
          </h3>
        </div>
        <!--end::Header-->

        <!--begin::Body-->
        <div class="card-body pt-0">


          <div class="form-group row mb-0">
            <b-form-group class="col-lg-6 mb-2" description="Введите курс доллара, только числа" label="Курс доллара:">
              <b-form-input v-model.number.trim="settings.dollar_rate" :class="{'is-invalid': errors.dollar_rate}"></b-form-input>
              <div v-if="errors.dollar_rate" class="invalid-feedback">{{errors.dollar_rate[0]}}</div>
            </b-form-group>
          </div>

          <div class="d-flex justify-content-between mt-5">
            <b-button @click="saveSettings" ref="save_settings" type="submit" variant="primary">Сохранить настройки</b-button>
          </div>


        </div>







      </div>
    </div>




</template>

<script>
    import {SET_BREADCRUMB} from "../../../core/services/store/breadcrumbs.module";
    import { mapGetters } from "vuex";
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    import {GET_SETTINGS, SET_SETTINGS_ERROR, UPDATE_SETTINGS} from "../../../core/services/store/settings.module";


    export default {
      name: "SiteSettings",
      mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [{title: "Настройки сайта"}]);
        this.getSettings()
        this.$store.commit(SET_SETTINGS_ERROR, {});
      },

      computed: {
        ...mapGetters({
          load: 'getSettingSiteLoad',
          settings: 'gettersSettingSite',
          errors: 'getSettingErrors',
        }),
      },


      methods: {


        showAlert(text, variant, type) {
          this.$store.commit(SET_ALERT, {text, variant, type});
        },

        async getSettings() {
          try {
            await this.$store.dispatch(GET_SETTINGS);
          } catch (e) {
            this.showAlert('Ошибка загрузки товара', 'danger', 'toast');
          }
        },


        async saveSettings() {

          const submitButton = this.$refs["save_settings"];
          submitButton.classList.add("spinner", "spinner-light", "spinner-right");

          try {
            await this.$store.dispatch(UPDATE_SETTINGS, this.settings)
            this.showAlert('Настройки сохранены', 'success');
            this.$router.push({name: "dashboard"})

          } catch (response) {
            if (response.status === 422) {
              this.showAlert('Заполните все поля', 'danger', 'toast');
            } else {
              this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
            }
          } finally {
            submitButton.classList.remove("spinner", "spinner-light", "spinner-right")
          }
        }


      }
    }
</script>

<style scoped>

</style>